import * as React from 'react';
import { IFacetResult, ITerm } from '../../state-helpers/facets';

export interface IProps {
    term: ITerm;
    onTermClick: () => void;
}

export const FacetTerm = ({ term, onTermClick } : IProps) => {
    
    //Don't show hits with 0 results or no text. If facet is Policy Types, show them all anyway
    if (!term.alwaysShow && (term.hits === 0 || term.term === '')) {
        return null;
    }

    const filterValue = term.term.replace(/\s+/g, '-').toLowerCase();

    //Apply disabled styling to hits with alwaysShow === true and 0 hits
    const disabled = term.alwaysShow && term.hits === 0;
    const divClass = 'form-element-checkbox' + (disabled ? ' form-element-checkbox-disabled' : '');

    const onKeyPress = (e: any) => {
        if (e.charCode == 13 || e.charCode == 32) {
            e.preventDefault();
            e.stopPropagation();
            onTermClick();
        }
    }

    return (
        <div className={divClass} tabIndex={0} onKeyPress={(e) => { onKeyPress(e) }}>

            <input
                type="checkbox"
                id={filterValue}
                name={filterValue}
                value={filterValue}
                className="form-element-checkbox"
                checked={term.selected}
                onChange={onTermClick}
                disabled={disabled}                
            />

            <label htmlFor={filterValue}>
                <svg className="selected">
                    <use xlinkHref="#checkbox-selected"></use>
                </svg>
                <svg className="unselected">
                    <use xlinkHref="#checkbox-unselected"></use>
                </svg>
            </label>

            <div className="form-element-checkbox-text">
                <p className="form-element-checkbox-text-term">{ term.displayTerm }</p>
                <p className="form-element-checkbox-text-number"><span className="search-facet-item-number">({term.hits})</span></p>
            </div>
        </div>
    );
}
